module.exports = __webpack_public_path__ + "img/gold2.4b0660ed.png";